export default __webpack_public_path__ + "static/media/logo__footer.fb3b8058.svg";